import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { handleAuthRedirect } from "@/utils/authUtils"; // Importa la lógica

const AuthRedirectHandler = () => {
  const { user, initialized } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    handleAuthRedirect(user, initialized, location.pathname, navigate, location.search);
  }, [user, initialized, location.pathname, location.search, navigate]);

  return null;
};

export default AuthRedirectHandler;
